import { render, staticRenderFns } from "./VendedorPage.vue?vue&type=template&id=0cbdd80f&scoped=true&"
import script from "./VendedorPage.vue?vue&type=script&lang=js&"
export * from "./VendedorPage.vue?vue&type=script&lang=js&"
import style0 from "./VendedorPage.vue?vue&type=style&index=0&id=0cbdd80f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbdd80f",
  null
  
)

export default component.exports